import UserForm from '../../components/UserForm/UserForm';
import { UPDATE_USER } from '../../constants';

function UserEdit() {
  return <UserForm type={UPDATE_USER} />;
}

export default UserEdit;
